// extracted by mini-css-extract-plugin
export default {"form":"InvitationForm_form__GnTG-"};